<template>
  <!-- 站点信息 -->
  <div>
      <w-table
        v-if="typeName"
        v-loading.body="tableLoading"
        :data-list="tableData"
        :columns="staticData[typeName].columns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        @pageNoChange="pageNoChange"
        @handleSizeChange="handleSizeChange"
        >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
          <span v-else-if="props.column.label === '时间'">
            <span>{{props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}</span>
          </span>
          <span v-else-if="props.column.label === '导入内容'">
            <span class="blue cursor" @click="onDownload(props.row.fileUrl)">查看</span>
          </span>
          <span v-else-if="props.column.label === '导入类型'">
            <span>{{getFileTypeStatus(props.row.fileType)}}</span>
          </span>
          <span v-else-if="props.column.label === '品牌名称'">
            <span>{{
              companyData.find(it=>Number(it.brandId)===Number(props.row.brandId))
                ? companyData.find(it=>Number(it.brandId)===Number(props.row.brandId)).brandName
                : ''
            }}</span>
          </span>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import staticData from './staticData.js'
import Api from '@/api'
import { mapGetters } from 'vuex'
import {downloadExcel} from '@/utils/tools'

export default {
  components: {
    WTable
  },
  props: ['typeName','companyData'],
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableLoading: false,
      tableData: []
    }
  },
  computed: {
    ...mapGetters(['selfAreaId']),
    staticData() {
      return staticData
    }
  },
  created() {
    this.initData()
  },
  methods: {
    onDownload(url) {
      downloadExcel(url)
    },
    getFileTypeStatus(type) {
      return {
        maintain_person: '运维人员信息',
        bicycle_excel: '核定自行车信息',
        electric_vehicle_excel: '核定电动车信息'
      }[type]
    },
    jjSearch(item) {
      this.$emit('jjSearch', item)
    },
    initData() {
      const vm = this
      vm.tableLoading = true
      const params = {
        selfAreaId: vm.selfAreaId,
        currentPage: vm.formData.pageNum,
        pageSize: vm.formData.pageSize
      }
      Api.getBrandChangeList(params)
        .then(res => {
          if (res.code === 200) {
            vm.tableData = res.data.lists
            vm.total = res.data.total
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
    },
    onShowDialog2(item) {
      const data = {
        ...item,
        type: 'bikes'
      }
      this.$emit('onShowDialog2', data)
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    }
  }
}
</script>
